module.exports = __webpack_public_path__ + "img/img10.31d431bb.svg";